"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveCell = void 0;
const react_redux_1 = require("react-redux");
const use_meta_1 = require("./use_meta");
const selector_1 = require("../store/selector");
const getActiveCell = (state, currentDatasheetId) => {
    if (!(0, selector_1.isCurrentDatasheetActive)(state, currentDatasheetId)) {
        return;
    }
    const selection = (0, selector_1.getSelection)(state);
    return selection === null || selection === void 0 ? void 0 : selection.activeCell;
};
/**
 * Get the coordinates of cell where the cursor is currently active, return a {@link ICell}.
 * Rerendering is triggered, When the cursor is moved or the view is switched.
 *
 * If you need to information not only about the activated cell, but also the selection,
 * please use {@link useSelection}.
 *
 * @param
 *
 * @returns
 *
 * ### Example
 * ```js
 * import { useActiveCell, useRecord } from '@apitable/widget-sdk';
 *
 * // Render the value of currently selected cell
 * function ActiveCell() {
 *   const activeCell = useActiveCell();
 *   const activeRecord = useRecord(activeCell?.recordId);
 *   if (!activeCell || !activeRecord) {
 *     return <p>Cells without activation</p>
 *   }
 *   return <p>Activated Cells: {activeRecord.getCellValueString(activeCell.fieldId)}</p>
 * }
 * ```
 */
function useActiveCell() {
    const { datasheetId } = (0, use_meta_1.useMeta)();
    return (0, react_redux_1.useSelector)(state => {
        return getActiveCell(state, datasheetId);
    });
}
exports.useActiveCell = useActiveCell;
